import { createContext } from 'react';
var WizardContext = createContext();
export default WizardContext;